module.exports = __webpack_public_path__ + "static/favicon-94270d4cbf549ddd0cf61fa15b86fc23.ico";